@if (contentId()) {
  <ui-cms-outlet [config]="{ contentId: contentId(), customerNumber: customerNumber() }"></ui-cms-outlet>
}
